module.exports = __webpack_public_path__ + "img/img5_4.a2939342.jpeg";